export type Theme = "light" | "dark";

const storageKey = "queueryte.theme";

/** A saved choice wins; otherwise follow the device setting. */
export function readTheme(storage: Pick<Storage, "getItem"> | null, prefersDark: boolean): Theme {
  try {
    const value = storage?.getItem(storageKey);
    if (value === "light" || value === "dark") return value;
  } catch { /* storage can be unavailable */ }
  return prefersDark ? "dark" : "light";
}

export function initialTheme(): Theme {
  if (typeof window === "undefined") return "light";
  return readTheme(window.localStorage, window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false);
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", theme === "dark" ? "#0f1720" : "#ffffff");
}

export function saveTheme(theme: Theme): void {
  try { window.localStorage.setItem(storageKey, theme); } catch { /* storage can be unavailable */ }
}
